"use client";
import Image from "next/image";
import Link from "next/link";
import React, { useEffect, useState } from "react";

export default function FacilitiesContent() {
    const [facilities, setFacilities] = useState([]);
    const [loading, setLoading] = useState(true);

    

    useEffect(() => {
        const fetchFacilities = async () => {
            try {
                const response = await fetch('/api/facilities');
                if (response.ok) {
                    const data = await response.json();
                    setFacilities(data);
                }
            } catch (error) {
                console.error('Failed to fetch facilities:', error);
            } finally {
                setLoading(false);
            }
        };
        fetchFacilities();
    }, []);

    if (loading) {
        return (
            <div className="d-flex justify-content-center align-items-center" style={{ minHeight: '80vh', width: '100%' }}>
                <div className="spinner-border" role="status" style={{ color: 'var(--theme-color, #F55B1F)', width: '3rem', height: '3rem' }}>
                    <span className="visually-hidden">Loading...</span>
                </div>
            </div>
        );
    }

    return (
        <>
            <div
                className="breadcrumb-wrapper bg-cover"
                style={{ backgroundImage: 'url("/assets/img/breadcrumb-bg.jpg")' }}
            >
                <div className="shape-image float-bob-y">
                </div>
                <div className="container">
                    <div className="breadcrumb-wrapper-items">
                        <div className="page-heading">
                            <div className="breadcrumb-sub-title">
                                <h1 className="wow fadeInUp" data-wow-delay=".3s">
                                    Facilties
                                </h1>
                            </div>
                            <ul
                                className="breadcrumb-items wow fadeInUp"
                                data-wow-delay=".5s"
                            >
                                <li>
                                    <Link href={`/`}> Home </Link>
                                </li>
                                <li>
                                    <i className="fa-sharp fa-solid fa-slash-forward" />
                                </li>
                                <li>Facilties</li>
                            </ul>
                        </div>
                        <div className="breadcrumb-image">
                            <div className="bar-shape">
                                <Image
                                    src="/assets/img/breadcrumb-bar.png"
                                    width={631}
                                    height={604}
                                    alt="img"
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="container py-5">
                <div className="row">
                    {facilities.length > 0 ? (
                        facilities.map((item, index) => (
                            <div className="col-lg-4 col-md-6 col-sm-12" key={item._id || index}>
                                <div className="card mb-4">
                                    <div className="card-body">
                                        <div className="service-box-items mt-0 pb-4">
                                            <div className="service-thumb">
                                                <img
                                                    src={item.imgSrc}
                                                    width={346}
                                                    height={236}
                                                    alt={item.title || "img"}
                                                    style={{ objectFit: 'cover' }}
                                                />
                                            </div>
                                            <div className="service-content">
                                                <h2 className="number">{item.number}</h2>
                                                <h3>
                                                    {/* <Link href={`/facilities/${item._id}`}> */}
                                                        {item.title}
                                                    {/* </Link> */}
                                                </h3>
                                                <p>{item.description}</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        ))
                    ) : (
                        <div className="text-center text-white">Loading facilities...</div>
                    )}
                </div>
            </div>
        </>
    );
}
